import * as frequences from "../../references/glossaire_frequence";

export const getFrequenceAndStartAndEndInterval = (
  currentFrequenceTab: number,
  currentActiveTab: string
) => {
  const { heure, jour, semaine, mois, trimestre, annee } = frequences;
  const data = {
    frequence: -1,
    start_interval: -1,
    end_interval: -1,
  };
  switch (currentFrequenceTab) {
    case 0: {
      // Dia
      data.frequence = currentActiveTab === "consommation" ? heure : jour;
      const startEndOfDay = getStartAndEndOfDay(new Date());
      data.start_interval = startEndOfDay.start_interval;
      data.end_interval = startEndOfDay.end_interval;
      break;
    }
    case 1: {
      // Semana
      data.frequence = currentActiveTab === "consommation" ? jour : semaine;
      const startOfweek = getStartAndEndOfWeek(new Date());
      data.start_interval = startOfweek.start_interval;
      data.end_interval = startOfweek.end_interval;
      break;
    }
    case 2: {
      // Mês
      data.frequence = currentActiveTab === "consommation" ? semaine : mois;
      const startEndOfMonth = getStartAndEndOfMonth(new Date());
      data.start_interval = startEndOfMonth.start_interval;
      data.end_interval = startEndOfMonth.end_interval;
      break;
    }
    case 3: {
      // Ano
      data.frequence = currentActiveTab === "consommation" ? trimestre : annee;
      const startEndOfYear = getStartAndEndOfYear(new Date());
      data.start_interval = startEndOfYear.start_interval;
      data.end_interval = startEndOfYear.end_interval;
      break;
    }
    default:
      // thorw error here ?
      break;
  }
  return data;
};

export const getCurrentDateAtMidnightUTC = () => {
  // Crée un objet Date pour minuit aujourd'hui dans la time zone locale
  const now = new Date();
  const localMidnight = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  );

  // Convertit cette date locale en UTC
  return (
    new Date(
      Date.UTC(
        localMidnight.getFullYear(),
        localMidnight.getMonth(),
        localMidnight.getDate()
      )
    ).getTime() / 1000
  );
};

export const getStartAndEndOfDay = (dateInput: Date) => {
  const date = new Date(dateInput);

  // Début de la journée à minuit
  const start_interval =
    new Date(date.setUTCHours(0, 0, 0, 0)).getTime() / 1000;

  // Fin de la journée: début de la journée suivante à minuit
  const end_interval = start_interval + 86400; // Ajoute 24 heures en secondes

  return { start_interval, end_interval };
};

export const getStartAndEndOfWeek = (dateInput: Date) => {
  const date = new Date(dateInput);
  date.setUTCHours(0, 0, 0, 0); // Ajuste la date pour minuit

  // Calcule le décalage jusqu'au lundi
  const day = date.getDay(); // Dimanche - 0, Lundi - 1, etc.
  const diff = day === 0 ? -6 : 1 - day; // Si c'est dimanche, décale de -6 jours, sinon décale pour revenir à lundi

  // Ajuste la date au lundi de la semaine
  date.setDate(date.getDate() + diff);
  const start_interval = date.getTime() / 1000; // Convertit en timestamp UNIX (secondes)
  const end_interval = start_interval + 86400 * 6; // Ajoute 6 jours pour arriver au dimanche suivant à minuit

  return { start_interval, end_interval };
};
export const getStartAndEndOfMonth = (dateInput: Date) => {
  const date = new Date(dateInput);
  date.setUTCHours(0, 0, 0, 0); // Ajuste la date pour minuit

  // Trouve le premier jour du mois
  const start_interval =
    new Date(
      date.getFullYear(),
      date.getMonth(),
      1,
      date.getHours()
    ).getTime() / 1000;

  // Trouve le dernier jour du mois
  const end_interval =
    new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      1,
      date.getHours()
    ).getTime() / 1000;

  return { start_interval, end_interval };
};
export const getStartAndEndOfYear = (dateInput: Date) => {
  const date = new Date(dateInput);
  date.setUTCHours(0, 0, 0, 0); // Ajuste la date pour minuit

  // Trouve le premier jour de l'année
  const start_interval =
    new Date(date.getFullYear(), 0, 1, date.getHours()).getTime() / 1000;

  // Trouve le dernier jour de l'année
  const end_interval =
    new Date(date.getFullYear() + 1, 0, 0, date.getHours()).getTime() / 1000;

  return { start_interval, end_interval };
};

export const utsToTicks = (t: number[], timeUnit: number) => {
  const { heure, jour, semaine, trimestre } = frequences;

  switch (timeUnit) {
    case heure:
      return convertUnixTimestampsToHours(t);
    case jour:
      return convertTimestampsToShortDayFormat(t);
    case semaine:
      return convertTimestampsToWeekNumber(t);
    case trimestre:
      return convertTimestampsToQuarterNumber(t);
    default:
      return (v: any) => v;
  }
};

// Funções de conversão para timestamps
export function convertUnixTimestampsToHours(timestamps: number[]) {
  return timestamps.map((timestamp) => {
    const date = new Date(timestamp * 1000);
    const hours = date.getHours().toString().padStart(2, "0");
    return hours + "h";
  });
}

export function convertTimestampsToShortDayFormat(timestamps: number[]) {
  return timestamps.map((timestamp) => {
    const date = new Date(timestamp * 1000);
    const formattedDate = date.toLocaleDateString("fr-FR", {
      weekday: "short",
      day: "numeric",
    });
    return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
  });
}

export function convertTimestampsToWeekNumber(timestamps: number[]) {
  return timestamps.map((timestamp) => {
    const date = new Date(timestamp * 1000);
    const weekNumber = getWeekNumber(date);
    return `S${weekNumber}`;
  });
}

export function getWeekNumber(d: Date) {
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
}

export function convertTimestampsToQuarterNumber(timestamps: number[]) {
  return timestamps.map((timestamp) => {
    const weekNumber = getQuarterFromTimestamp(timestamp);
    return `T${weekNumber}`;
  });
}

export function getQuarterFromTimestamp(utcTimestamp: number) {
  const date = new Date(utcTimestamp * 1000);
  const month = date.getMonth();
  return Math.ceil((month + 1) / 3);
}

// filtrer les données de débits pour toujours afficher 9 éléments au dessus de la médiane et 10 en dessous
// si moins de 20 elements, on affiche juste tout
export function getFilteredData<T>(
  adjustedData: T[],
  indexSensor: number,
  leftItems: number,
  rightItems: number
): { filteredData: T[]; relativeIndex: number } {
  if (adjustedData.length < 20) {
    return { filteredData: adjustedData, relativeIndex: indexSensor };
  }

  const actualSensor = adjustedData[indexSensor];
  const aboveMedianeArray = adjustedData.slice(
    0,
    Math.round(adjustedData.length / 2)
  );
  const belowMedianeArray = adjustedData.slice(
    Math.round(adjustedData.length / 2),
    adjustedData.length - 1
  );

  const aboveStepArray = getEveryStepElement(
    aboveMedianeArray,
    Math.round(aboveMedianeArray.length / leftItems)
  );
  const belowStepArray = getEveryStepElement(
    belowMedianeArray,
    Math.round(belowMedianeArray.length / rightItems)
  );
  const filteredData = [...aboveStepArray, actualSensor, ...belowStepArray];
  filteredData.sort((debitA, debitB) => {
    if (debitA.debit > debitB.debit) {
      return -1;
    } else if (debitA.debit < debitB.debit) {
      return 1;
    } else {
      return 0;
    }
  });

  const result = new Set(filteredData);
  return {
    filteredData: Array.from(result),
    relativeIndex: filteredData.indexOf(actualSensor),
  };
}

// fonction utilitaire pour récupérer les valeurs d'un tabeleau tous les "step" index
export function getEveryStepElement(arr: any[], step: number) {
  const result = [];
  for (let i = step - 1; i < arr.length; i += step) {
    result.push(arr[i]);
  }
  return result;
}
